<template>
  <div class="dashboard dashboard__root">
    <pui-flex class="dashboard__maintenance-container" direction="column" alignItems="center">
      <div class="dashboard__title">{{ $t('dam.dashboard.title_maintenance') }}</div>
      <div class="dashboard__subtitle">{{ $t('dam.dashboard.subtitle_maintenance') }}</div>
      <img :src="imgMaintenance" class="dashboard__maintenance-img" />
    </pui-flex>
  </div>
</template>

<script>
import imgMaintenance from '../static/img/illu-maintenance.svg';

export default {
  data() {
    return {
      imgMaintenance,
    };
  },
};
</script>
